import React from 'react';

const SpamhausEDROPAdapterSummary = () => {
  return (<dl>
    <i>No configuration required.</i>
  </dl>);
};

export default SpamhausEDROPAdapterSummary;
